import React, { useState } from 'react'

//component
import IcEdit from '../../../../../../../assets/images/IcEdit'
import IcDelete from '../../../../../../../assets/images/IcDetete'
import MoreOption from '../../../../../../Control/MoreOption'
import PopupDelBank from './PopupDelBank'
import Portal from '../../../../../../Control/Portal'
import PopupCannotDelBank from './PopupCannotDelBank'
import PopupEditBank from './PopupEditBank'


const EDIT = 'EDIT'
const DEL = 'DEL'
const ALERT_CANNOT_DEL = 'ALERT_CANNOT_DEL'

const OptionBank = ({ bankData, isDetails, refList}) => {
    
    const [keyShowForm, setKeyShowForm] = useState('');

    const handleEdit = (e) => {
        setKeyShowForm(EDIT)
    }

    const handleDel = () => {
        setKeyShowForm(DEL)
    }

    const handleClose = (e) => {
        e.stopPropagation()
        setKeyShowForm('')
    }

    const dataMoreOption = [
        {
            Icon: IcEdit,
            text: "Sửa thông tin",
            handleOption: handleEdit
        },
        {
            Icon: IcDelete,
            text: "Xóa Bank",
            handleOption: handleDel
        },
    ]

    return (
        <>
            <MoreOption
                dataOption={dataMoreOption}
                refList={refList}
            />
            {
                keyShowForm === DEL &&
                <Portal>
                    <PopupDelBank
                        bankData={bankData}
                        handleClose={handleClose}
                        setKeyShowForm={setKeyShowForm}
                        isDetails={isDetails}
                    />
                </Portal>
            }
            {/* {
                keyShowForm === ALERT_CANNOT_DEL &&
                <Portal>
                    <PopupCannotDelBank 
                        handleClose={handleClose}
                    />
                </Portal>
            } */}
            {
                keyShowForm === EDIT &&
                <Portal>
                    <PopupEditBank
                        bankData={bankData}
                        onClickIconClose={handleClose}
                        setKeyShowForm={setKeyShowForm}
                        isDetails={isDetails}
                    />
                </Portal>
            }
        </>
    )
}

export default OptionBank
